"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-lorenzo-dorsino": {
    "a20315a4": [{
      "hkey": "71b7eb97",
      "slug": "san-lorenzo-dorsino",
      "name": "San Lorenzo Dorsino",
      "primary": true,
      "skipSearch": false
    }],
    "berghi": [{
      "hkey": "71b7eb97",
      "slug": "san-lorenzo-dorsino",
      "name": "San Lorenzo Dorsino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "754da0c0": [{
      "hkey": "71b7eb97",
      "slug": "san-lorenzo-dorsino",
      "name": "San Lorenzo Dorsino",
      "primary": true,
      "skipSearch": false
    }],
    "deggia": [{
      "hkey": "71b7eb97",
      "slug": "san-lorenzo-dorsino",
      "name": "San Lorenzo Dorsino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c6fbb7d1": [{
      "hkey": "71b7eb97",
      "slug": "san-lorenzo-dorsino",
      "name": "San Lorenzo Dorsino",
      "primary": true,
      "skipSearch": false
    }],
    "dolaso": [{
      "hkey": "71b7eb97",
      "slug": "san-lorenzo-dorsino",
      "name": "San Lorenzo Dorsino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fccd5986": [{
      "hkey": "71b7eb97",
      "slug": "san-lorenzo-dorsino",
      "name": "San Lorenzo Dorsino",
      "primary": true,
      "skipSearch": false
    }],
    "glolo": [{
      "hkey": "71b7eb97",
      "slug": "san-lorenzo-dorsino",
      "name": "San Lorenzo Dorsino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f63f14a7": [{
      "hkey": "71b7eb97",
      "slug": "san-lorenzo-dorsino",
      "name": "San Lorenzo Dorsino",
      "primary": true,
      "skipSearch": false
    }],
    "nembia": [{
      "hkey": "71b7eb97",
      "slug": "san-lorenzo-dorsino",
      "name": "San Lorenzo Dorsino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "50f1d7c7": [{
      "hkey": "71b7eb97",
      "slug": "san-lorenzo-dorsino",
      "name": "San Lorenzo Dorsino",
      "primary": true,
      "skipSearch": false
    }],
    "pergnano": [{
      "hkey": "71b7eb97",
      "slug": "san-lorenzo-dorsino",
      "name": "San Lorenzo Dorsino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "82b2048a": [{
      "hkey": "71b7eb97",
      "slug": "san-lorenzo-dorsino",
      "name": "San Lorenzo Dorsino",
      "primary": true,
      "skipSearch": false
    }],
    "prato": [{
      "hkey": "71b7eb97",
      "slug": "san-lorenzo-dorsino",
      "name": "San Lorenzo Dorsino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "53bd4f9b": [{
      "hkey": "71b7eb97",
      "slug": "san-lorenzo-dorsino",
      "name": "San Lorenzo Dorsino",
      "primary": true,
      "skipSearch": false
    }],
    "prusa": [{
      "hkey": "71b7eb97",
      "slug": "san-lorenzo-dorsino",
      "name": "San Lorenzo Dorsino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "5a76938a": [{
      "hkey": "71b7eb97",
      "slug": "san-lorenzo-dorsino",
      "name": "San Lorenzo Dorsino",
      "primary": true,
      "skipSearch": false
    }],
    "senaso": [{
      "hkey": "71b7eb97",
      "slug": "san-lorenzo-dorsino",
      "name": "San Lorenzo Dorsino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;